import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { name } from '@azure/msal-angular/packageMetadata';
import { filter, Subject, takeUntil } from 'rxjs';
import { HomeService } from 'src/app/services/home/home.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit {
  @Input() isMenuCollapsed: boolean = true;
  persona: string = '';
  clientName: any = '';
  public userDetails: any;
  engagementId!: number | string;
  @Output() menuCollapsedFromHeaderEvent = new EventEmitter(this.isMenuCollapsed);
  private destroy$: Subject<void> = new Subject<void>();

  constructor(private route: ActivatedRoute,public userService: UserService,private homeService: HomeService,private router: Router) {
    this.homeService.engagementId.pipe(takeUntil(this.destroy$)).subscribe((id)=>{
      this.engagementId = id;    
    })
  }

  ngOnInit(): void {
    this.userDetails = this.userService.userDetails;
    this.extractIdFromRoute();
    
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.extractIdFromRoute();
      });

    this.homeService.persona$.subscribe(persona => {
      this.persona = persona;
    });

  }

  private extractIdFromRoute(): void {
    let activeRoute = this.route;

    while (activeRoute.firstChild) {
      activeRoute = activeRoute.firstChild;
    }

    activeRoute.paramMap.subscribe(params => {
      let id: any = params.get('id');
      this.homeService.getClientDetails(id).subscribe(res => {
        if (Array.isArray(res) && res.length > 0) {
          this.clientName = res[0].clientName;
        }
      })
    });
  }

  menuToggleHandler() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.menuCollapsedFromHeaderEvent.emit(this.isMenuCollapsed);
  }

  formatClientName(clientName: string): string {
    return clientName.toLowerCase().replace(/\s+/g, '-');
  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

  onPersonaChange(newPersona: string) {
    this.homeService.setPersona(newPersona);
  }
}
